export default ({
}) => ({
    key: { name: 'Team' },
})
